import React from 'react';

const FundingSubmissionDocumentChecklist = ({ submission }) => {
  const required = submission.requiredDocuments || [];
  const missing = submission.missingDocuments || [];
  const attachedCount = submission.attachedDocumentIds?.length || 0;

  if (!required.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No required documents configured.</p>;
  }

  return (
    <div className="space-y-2">
      <div className="text-sm font-semibold text-[var(--fg-text)]">Document checklist</div>
      <div className="text-xs text-[var(--fg-muted)]">{attachedCount} attached · {missing.length} missing</div>
      <ul className="space-y-1 text-sm">
        {required.map((doc) => {
          const isMissing = missing.includes(doc);
          return (
            <li key={doc} className={`flex items-center gap-2 ${isMissing ? 'text-amber-700 dark:text-amber-300' : 'text-[var(--fg-text)]'}`}>
              <span>{isMissing ? '○' : '●'}</span>
              <span>{doc}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FundingSubmissionDocumentChecklist;
